














import { GatewayHealthQueryStringMixin } from '@/features/core/components/mixins/gateway-health-query-string';
import { PaginationQueryStringMixin } from '@/features/core/components/mixins/pagination-query-string';
import { Component, Mixins } from 'vue-property-decorator';
import gatewaysQuery from './gateways.gql';
import query from './view.gql';
import {
  AppManagerAppGatewaysViewGatewaysQuery,
  AppManagerAppGatewaysViewGatewaysQueryVariables,
} from './__generated__/AppManagerAppGatewaysViewGatewaysQuery';
import { AppManagerAppGatewaysViewQuery } from './__generated__/AppManagerAppGatewaysViewQuery';

@Component({
  apollo: {
    healths: {
      query,
      pollInterval: 60000,
    },
    gateways: {
      query: gatewaysQuery,
      pollInterval: 60000,
      variables(this: GatewaysView): AppManagerAppGatewaysViewGatewaysQueryVariables {
        return {
          take: this.take,
          skip: this.skip,
          healths: this.health === undefined ? undefined : [this.health],
          searchTerm: this.searchTerm,
        };
      },
    },
  },
  data() {
    return { healths: undefined, gateways: undefined };
  },
})
export default class GatewaysView extends Mixins(GatewayHealthQueryStringMixin, PaginationQueryStringMixin) {
  private readonly healths?: AppManagerAppGatewaysViewQuery['healths'];
  private readonly gateways?: AppManagerAppGatewaysViewGatewaysQuery['gateways'];

  protected get count(): number {
    return this.gateways?.count ?? 0;
  }
  protected get searchTerm(): string | undefined {
    return (this.$route.query.searchTerm as string) ?? undefined;
  }

  protected set searchTerm(searchTerm: string | undefined) {
    const query = { ...this.$route.query }; // Make a copy of the current query object

    if (searchTerm === this.searchTerm || !searchTerm || searchTerm.length < 3) {
      delete query.searchTerm; // Remove the searchTerm from the query object
    } else {
      query.searchTerm = searchTerm; // Update the searchTerm in the query object
    }

    // Replace the current route with the updated query object
    void this.$router.replace({ query });
  }
}
